import { useAuth0 } from '@auth0/auth0-vue'

/** How long to wait for Auth0 to restore a session before carrying on. */
const AUTH_TIMEOUT = 10000 // ms

export default defineNuxtRouteMiddleware(async () => {
  const { isLoading, checkSession } = useAuth0()

  // Was a 1s polling loop, so the first navigation of a session always cost up
  // to a full second even when Auth0 had already settled. A timeout rather
  // than a throw: if Auth0 never settles, checkSession() below reports it.
  await until(isLoading).toBe(false, { timeout: AUTH_TIMEOUT })

  await checkSession().catch(e => console.error(e))
})
